import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import {
  Button,
  type ButtonProps,
  notifyError,
  notifyWarning,
} from '@omnipresentgroup/design-system';
import { useDocumentDownload } from '@omnipresentgroup/domains';
import { useState } from 'react';

const DOCUMENT_BEING_PROCESSED_MESSAGE =
  'This document is being processed and will be available soon.';

export const DownloadButton = ({
  id,
  viewMode,
  ...buttonProps
}: {
  id: string;
  viewMode?: boolean;
} & ButtonProps<'div'>) => {
  const [isLoading, setIsLoading] = useState(false);

  const { downloadDocument } = useDocumentDownload();

  const downloadDocumentHandler = () => {
    setIsLoading(true);
    const payload = viewMode
      ? {
          documentId: id,
          disposition: 'inline',
        }
      : {
          documentId: id,
        };
    const target = viewMode ? '_blank' : '_self';

    downloadDocument(payload)
      .then(({ documentLink, status }) => {
        if (status === HTTPStatusCodes.ACCEPTED) {
          notifyWarning({
            title: DOCUMENT_BEING_PROCESSED_MESSAGE,
          });
        } else {
          window.open(documentLink, target);
        }
      })
      .catch(() => {
        notifyError({
          title: 'Error',
          description: 'Something went wrong while downloading the document.',
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Button
      variant="secondary"
      size="small"
      loading={isLoading}
      {...buttonProps}
      onClick={() => {
        downloadDocumentHandler();
      }}
    >
      {buttonProps.children || 'Download'}
    </Button>
  );
};
